import { SliceableHelper } from '../helpers/SliceableHelper';
import { SubplaceEvents } from '../helpers/SubplaceCountsHelper';
import { ISliceable } from '../models/ISliceable';
import { Set } from '../models/Set';
import { Module } from '../Module';

interface ISelectionMenuScope extends ng.IScope {
  selection: Set<any>;
  sliceable: ISliceable<any>;

  selectAll: () => any;
  selecting: boolean;
}

export let SelectionEvent = {
  SelectionStarted: 'selectionStartedEvent',
  SelectionEnded: 'selectionEndedEvent'
};

Module.instance().directive('tbSelectionMenu',
  () => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'selectionMenu.html',
      scope: {
        selection: '=',
        sliceable: '='
      },
      link: ($scope: ISelectionMenuScope) => {
        let cancelSelectAll = false;
        $scope.$on('$destroy', () => {
          cancelSelectAll = true;
        });
        $scope.selectAll = () => {
          $scope.$emit(SubplaceEvents.Refresh);
          $scope.$emit(SelectionEvent.SelectionStarted);
          $scope.selecting = true;
          SliceableHelper.fetchAll($scope.sliceable, (items: any[]) => {
            $scope.selection.addItems(items);
            return cancelSelectAll;
          }).finally(() => {
            $scope.$emit(SelectionEvent.SelectionEnded);
            $scope.selecting = false;
          });
        };
      }
    };
  }
);
